// src/modules/invitation/composables/useToast.ts
import { reactive, readonly } from 'vue'

export type ToastType = 'error' | 'success' | 'info'

export interface ToastItem {
  id: number
  message: string
  type: ToastType
  duration: number
}

// ─── Store global único ───
const state = reactive({
  items: [] as ToastItem[],
})

let nextId = 1

export function addToast(message: string, type: ToastType = 'error', duration = 6000): number {
  const id = nextId++
  state.items.push({ id, message, type, duration })
  
  console.log('[Toast] Agregado:', message, 'Total:', state.items.length)
  
  if (duration > 0) {
    setTimeout(() => removeToast(id), duration)
  }
  return id
}

export function removeToast(id: number) {
  const idx = state.items.findIndex((t) => t.id === id)
  if (idx >= 0) {
    state.items.splice(idx, 1)
    console.log('[Toast] Removido id:', id, 'Restantes:', state.items.length)
  }
}

// Exportamos el estado como readonly para que solo se modifique vía funciones
export const toasts = readonly(state.items)